module.exports = __webpack_public_path__ + "img/w4-b4.9fc6a358.jpg";